import Instance from '../../../Axios';

// New Actions for the app

const GetParceirosAlimentacao = () => async (dispatch) => {
  await Instance()
    .get(`/backend/parceiros/alimentacaoDropdown`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: 'GET_PARCEIROS_ALIMENTACAO', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetParceirosAlimentacao;
